document.addEventListener("DOMContentLoaded", function() {
document.addEventListener('click', function (e) { 
  const btn = e.target.closest('.product-atc, .product__sticky__bar-add-cart'); 
    if (!btn) return;
  e.preventDefault();       
  console.log('test');
   // --- Show loader on button ---
  btn.classList.add('loading');

     const purchaseOption = document.querySelector('input[name="purchase-option"]:checked')?.value;
    if (purchaseOption === "onetime") {
      if (window.ctrSubscriptionPopup && window.ctrSubscriptionPopup.intercept()) {
        btn.classList.remove("disable", "loading");
        btn.disabled = false;
        return;
      }
    }
  // Get quantity and variant ID
  const quantityInput = document.querySelector('.quantity__input');
  const qty = parseInt(quantityInput.value, 10) || 1;

  const productInput = document.querySelector('.product-input');
  const variantId = productInput ? productInput.value : null;

  if (!variantId) {
    console.error('No variant ID found.');
    return;
  }

  // Check which purchase option is selected
  const selectedPurchaseOption = document.querySelector('input[name="purchase-option"]:checked');
  let sellingPlanId = null;

  if (selectedPurchaseOption && selectedPurchaseOption.value === 'subscription') {
    const subscriptionSelect = document.querySelector('#global-subscription-plan');
    if (subscriptionSelect) {
      sellingPlanId = subscriptionSelect.value;
    }
  }

  // Prepare data
  const formData = {
    items: [
      {
        id: variantId,
        quantity: qty,
        ...(sellingPlanId && { selling_plan: sellingPlanId })
      }
    ]
  };

  if (window.ctrSubscriptionPopup && window.ctrSubscriptionPopup.applyToItems) {
    window.ctrSubscriptionPopup.applyToItems(formData.items);
  }

  // Shopify AJAX API
  fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(formData)
  })
    .then(res => res.json())
    .then(data => {
      // If Shopify responds with an error JSON (e.g. sold out)
      if (data.status && data.message) {
        // This happens when variant is unavailable
        alert(data.message || 'This item is sold out.');
        return; // Do not open cart drawer
      }

      console.log('Added to cart:', data);
    //   if (window.openSidecart) {
    //     window.openSidecart();
    //     if (window.fetchCart) window.fetchCart();
    //   }
    window.location.href="/checkout";
    })
    .catch(err => {
      // Network or unexpected error
      console.error('Error adding to cart:', err);
      alert('Could not add item to cart. It may be sold out.');
    })
     .finally(() => {
      // --- Hide loader ---
      btn.classList.remove('loading');
    });
});
});
// Price update functions code start here


document.addEventListener('DOMContentLoaded', function () {
  const subRadio = document.querySelector('#radio-sub');
  const oneTimeRadio = document.querySelector('#radio-onetime');
  const subPriceEl = document.querySelector('.subscription-original-price');
  const subDiscountEl = document.querySelector('.subscription-discount-price');
  const oneTimePriceEl = document.querySelector('.one-time-discount-price');
  const quantityInput = document.querySelector('.quantity__input');
  const totalPriceEls = document.querySelectorAll('.product-total-price'); 

  // Detect product type (must be in your HTML container)
  const productType = document.querySelector('#subscription-options-block')?.dataset.productType || '';

  function parsePrice(str) {
    return parseFloat(str.replace(/[^0-9.]/g, '')) || 0;
  }

  function setTotalPrice(value) {
    totalPriceEls.forEach(el => {
      el.textContent = `$${value}`;
    });
  }

  // --- Calculate subscription total ---
function calculateSubscriptionTotal(qty) {
  const basePrice = parsePrice(subPriceEl.dataset.originalPrice);
  let discountPercent = 0;
  const subpopupdiscount = document.querySelector('.sub-discount');

  if (productType === '4PackBundle') {
    if (qty === 1) discountPercent = 20.72;
    else if (qty === 2) discountPercent = 23.15;
    else discountPercent = 38.58;
  }
  else if (productType === '2PackBundle') {
    if (qty === 1) discountPercent = 18.58;
    else if (qty === 2) discountPercent = 20.72;
    else discountPercent = 23.34;
  }
  else if (productType === '3PackBundle') {
    if (qty === 1) discountPercent = 19.05;
    else discountPercent = 23.34;
  }
  else if (productType === 'FullSizeBundle') {
    if (qty === 1) discountPercent = 20;
    else if (qty === 2) discountPercent = 23;
    else if (qty === 3) discountPercent = 27;
    else discountPercent = 30;
  }

  const originalTotal = basePrice * qty;
  const discountAmount = originalTotal * (discountPercent / 100);
  const discountedTotal = originalTotal - discountAmount;
  const subscriptionDiscount = originalTotal - discountedTotal;

  if (subPriceEl) subPriceEl.textContent = `$${originalTotal.toFixed(2)}`;
  if (subDiscountEl) subDiscountEl.textContent = `$${discountedTotal.toFixed(2)}`;

  // Store temporarily so One-Time func can read it later
  window.subscriptionDiscountValue = subscriptionDiscount;

  // *** Popup updated later after one-time discount is calculated ***

  return discountedTotal;
}



  // --- Calculate one-time total ---
function calculateOneTimeTotal(qty) {
  const basePrice = parsePrice(oneTimePriceEl.dataset.onetimePrice);
  let perItemDiscount = 0;

  if (productType === '4PackBundle') {
    perItemDiscount = (qty === 1) ? 16 : 27.98;
  }
  else if (productType === '2PackBundle') {
    if (qty === 1) perItemDiscount = 3;
    else if (qty === 2) perItemDiscount = 8;
    else perItemDiscount = 11.66;
  }
  else if (productType === '3PackBundle') {
    perItemDiscount = (qty === 1) ? 9 : 17.49;
  }
  else if (productType === 'FullSizeBundle') {
    if (qty === 1) perItemDiscount = 0;
    else if (qty === 2) perItemDiscount = 4.00;
    else if (qty === 3) perItemDiscount = 6.40;
    else perItemDiscount = 8.00;
  }

  const oneTimeDiscount = qty * perItemDiscount;
  const originalTotal = basePrice * qty;
  const discountedTotal = originalTotal - oneTimeDiscount;

  if (oneTimePriceEl) oneTimePriceEl.textContent = `$${discountedTotal.toFixed(2)}`;

  // Now calculate popup value
  const subscriptionDiscount = window.subscriptionDiscountValue || 0;
  const popupValue = oneTimeDiscount - subscriptionDiscount;

  const subpopupdiscount = document.querySelector('.sub-discount');
  if (subpopupdiscount) {
    subpopupdiscount.textContent = `$${Math.abs(popupValue).toFixed(2)}`;
  }

  return discountedTotal;
}



  function updateTotal() {
    const qty = parseInt(quantityInput.value, 10) || 1;

    const subscriptionTotal = calculateSubscriptionTotal(qty);
    const oneTimeTotal = calculateOneTimeTotal(qty);

    if (subRadio.checked) {
      setTotalPrice(subscriptionTotal.toFixed(2));
    } else if (oneTimeRadio.checked) {
      setTotalPrice(oneTimeTotal.toFixed(2));
    }
  }

  subRadio.addEventListener('change', updateTotal);
  oneTimeRadio.addEventListener('change', updateTotal);
  quantityInput.addEventListener('input', updateTotal);

  document.querySelectorAll('.quantity__button').forEach(btn => {
    btn.addEventListener('click', () => {
      setTimeout(updateTotal, 50);
    });
  });

  updateTotal();
});




// Price update functions code end here
// Update quantity code in stickybar start  here and vice versa
document.addEventListener("DOMContentLoaded", function() {
  const mainQtyInput = document.querySelector(".product-form__quantity .quantity__input");
  const stickyQtyInput = document.querySelector(".product__sticky__bar-quantity .quantity__input");

  console.log("Main qty input:", mainQtyInput);
  console.log("Sticky qty input:", stickyQtyInput);

  if (mainQtyInput && stickyQtyInput) {
    // --- Sync on page load ---
    stickyQtyInput.value = mainQtyInput.value;

    // --- When main quantity changes → update sticky bar ---
    mainQtyInput.addEventListener("input", syncMainToSticky);
    mainQtyInput.addEventListener("change", syncMainToSticky);

    // --- When sticky quantity changes → update main ---
    stickyQtyInput.addEventListener("input", syncStickyToMain);
    stickyQtyInput.addEventListener("change", syncStickyToMain);

    function syncMainToSticky() {
      stickyQtyInput.value = mainQtyInput.value;
    }

    function syncStickyToMain() {
      mainQtyInput.value = stickyQtyInput.value;
    }

    // --- EXTRA: Ensure plus/minus buttons trigger sync ---
    const observer = new MutationObserver(() => {
      stickyQtyInput.value = mainQtyInput.value;
    });
    observer.observe(mainQtyInput, { attributes: true, attributeFilter: ['value'] });
  }
});

document.addEventListener('DOMContentLoaded', function () {
  // Grab main product block inside .non-subscription
  const mainWrapper = document.querySelector('.non-subscription');
  const mainQty = mainWrapper ? mainWrapper.querySelector('.quantity__input') : null;
  const plusMain = mainWrapper ? mainWrapper.querySelector('button[name="plus"]') : null;
  const minusMain = mainWrapper ? mainWrapper.querySelector('button[name="minus"]') : null;

  // Grab sticky bar quantity input
  const stickyWrapper = document.querySelector('.product__sticky-bar');
  const stickyQty = stickyWrapper ? stickyWrapper.querySelector('.quantity__input') : null;
  const plusSticky = stickyWrapper ? stickyWrapper.querySelector('button[name="plus"]') : null;
  const minusSticky = stickyWrapper ? stickyWrapper.querySelector('button[name="minus"]') : null;

  // Get base price from main plus button or set to 0
  const basePrice = plusMain && plusMain.dataset.price
    ? parseFloat(plusMain.dataset.price.replace(/[^\d.]/g, '')) || 0
    : 0;

  function clampQty(v) { return Math.max(1, parseInt(v, 10) || 1); }

  function syncQtyAndPrice(fromInput) {
    const qty = clampQty(fromInput.value);

    // Sync both inputs
    if (mainQty && mainQty !== fromInput) mainQty.value = qty;
    if (stickyQty && stickyQty !== fromInput) stickyQty.value = qty;

    // Update all price displays
    const total = (basePrice * qty).toFixed(2);
    document.querySelectorAll('.product-total-price').forEach(el => {
      el.textContent = `$${total}`;
    });
  }

  // Listen for manual input
  if (mainQty) {
    mainQty.addEventListener('input', () => syncQtyAndPrice(mainQty));
    mainQty.addEventListener('change', () => syncQtyAndPrice(mainQty));
  }
  if (stickyQty) {
    stickyQty.addEventListener('input', () => syncQtyAndPrice(stickyQty));
    stickyQty.addEventListener('change', () => syncQtyAndPrice(stickyQty));
  }

  // Listen for plus/minus (theme updates quantity automatically)
  if (plusMain) plusMain.addEventListener('click', () => setTimeout(() => syncQtyAndPrice(mainQty), 0));
  if (minusMain) minusMain.addEventListener('click', () => setTimeout(() => syncQtyAndPrice(mainQty), 0));
  if (plusSticky) plusSticky.addEventListener('click', () => setTimeout(() => syncQtyAndPrice(stickyQty), 0));
  if (minusSticky) minusSticky.addEventListener('click', () => setTimeout(() => syncQtyAndPrice(stickyQty), 0));

  // Initialize on load
  if (mainQty) syncQtyAndPrice(mainQty);
});

// Update quantity code in stickybar end  here and vice versa

// Subscription sorting code start here
// document.addEventListener('DOMContentLoaded', function () {
//   const select = document.getElementById('global-subscription-plan');
//   const options = Array.from(select.options);

//   // Define your desired order exactly as it appears in the text
//   const order = [
//     "Delivered every 4 weeks",
//     "Delivered every 6 weeks",
//     "Delivered every 2 months",
//     "Delivered every 3 months",
//     "Delivered every 4 months"
//   ];

//   options.sort((a, b) => {
//     const indexA = order.indexOf(a.textContent.trim());
//     const indexB = order.indexOf(b.textContent.trim());

//     // If an option is not in the order array, put it at the end
//     return (indexA === -1 ? Infinity : indexA) - (indexB === -1 ? Infinity : indexB);
//   });

//   // Remove existing options and append the sorted ones
//   select.innerHTML = '';
//   options.forEach(opt => select.appendChild(opt));
// });
// Subscription sorting code end here


//Upsell addtocart code start here

document.addEventListener("DOMContentLoaded", function() {
  document.querySelectorAll('.btn-upsell').forEach(function(button) {
    button.addEventListener('click', function() {
       const btn = this;  
        // --- Show loader ---
      btn.classList.add('loading');
      const variantId = this.getAttribute('data-variant-id');

      if (!variantId) {
        console.error("No variant ID found on button.");
        return;
      }

      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({
          id: variantId,
          quantity: 1
        })
      })
      .then(response => response.json())
      .then(data => {
        console.log("Product added to cart:", data);
         if (window.openSidecart) {
        window.openSidecart();
        if (window.fetchCart) window.fetchCart();
         }
      })
      .catch(error => {
        console.error("Error adding to cart:", error);
         alert("Error adding to cart: " + error);
      })
         .finally(() => {
      // --- Hide loader ---
      btn.classList.remove('loading');
    });
    });
  });
});


//upsell addtocart code end here


